export default function hasScrolledToElement(node: Element | Text | null) {
    if (!node || isSSR || node instanceof Text) {
        return false;
    }
    const { top } = node.getBoundingClientRect();
    return top <= window.innerHeight;
}
